import React, { useCallback } from "react";
import {
  WidthProvider,
  ResponsiveProps,
  WidthProviderProps,
  Responsive,
} from "react-grid-layout";

import { layoutSignal } from "@/store/layout-signal";

// react-grid-layout's ComponentClass type references the old React.Component.refs
// shape which is incompatible with React 18 types. Cast to bypass the JSX check.
const Grid = WidthProvider(Responsive) as unknown as React.ComponentType<
  ResponsiveProps & WidthProviderProps & { children?: React.ReactNode }
>;
type BaseGridLayoutProps = ResponsiveProps & WidthProviderProps;

type Props = BaseGridLayoutProps & {
  children: React.ReactNode;
};

export const WIDGET_GRID_COLS = 12;
export const WIDGET_GRID_ROW_HEIGHT = 20;
/** [horizontal, vertical] gap between grid items, in pixels. */
export const WIDGET_GRID_MARGIN: [number, number] = [10, 10];

const WidgetGridLayout = ({ children, ...restProps }: Props) => {
  const breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
  const cols = {
    lg: WIDGET_GRID_COLS,
    md: WIDGET_GRID_COLS,
    sm: WIDGET_GRID_COLS,
    xs: WIDGET_GRID_COLS,
    xxs: WIDGET_GRID_COLS,
  };

  const onWidthChange = useCallback(() => {
    layoutSignal.trigger.updateLayout();
  }, [layoutSignal]);

  return (
    <Grid
      onWidthChange={onWidthChange}
      className="layout"
      breakpoints={breakpoints}
      cols={cols}
      rowHeight={WIDGET_GRID_ROW_HEIGHT}
      margin={WIDGET_GRID_MARGIN}
      compactType="vertical"
      {...restProps}
    >
      {children}
    </Grid>
  );
};

export default WidgetGridLayout;
